import { FC, ReactElement } from 'react';

import { Cell, CellRightLabel, CellText, CheckableCard, Checkbox } from '@hh.ru/magritte-ui';

import FilterCount from 'src/components/Search/Common/Filters/FilterCount';

import styles from './styles.less';

interface SelectorOptionProps {
    isSelected: boolean;
    isIndeterminate?: boolean;
    onClick: () => void;
    text: string;
    textIcon?: ReactElement;
    count?: number;
    hideCounter?: boolean;
}

const SelectorOption: FC<SelectorOptionProps> = ({
    isSelected,
    isIndeterminate,
    onClick,
    text,
    textIcon,
    count,
    hideCounter,
}) => {
    return (
        <CheckableCard type="checkbox" checked={isSelected} onChange={onClick} padding={16} borderRadius={12} flexible>
            <Cell
                left={<Checkbox checked={isSelected} indeterminate={isIndeterminate} readOnly tabIndex={-1} />}
                right={
                    !hideCounter || count ? (
                        <CellRightLabel hideIcon>
                            <FilterCount count={count || 0} />
                        </CellRightLabel>
                    ) : undefined
                }
            >
                <CellText>
                    <div className={styles.optionTextWrapper}>
                        {textIcon}
                        {text}
                    </div>
                </CellText>
            </Cell>
        </CheckableCard>
    );
};

export default SelectorOption;
